import { Box, Typography, Divider } from '@mui/material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import Header from './components/role.header';
import CustomRoleTable from './components/role.table';
import RoleController from '../controller/role.controller';
import { useEffect } from 'react';
import { RoleChildrenModel, RoleModalChildrenData } from '../data/role.modal.child';
import { RoleModalNames } from '../data/role.modal.name';
import RoleModalView from './components/role.modal.view';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import useScreenWidth from '../../../hooks/use-page-width';
const RolePage = () => {
    const role = RoleController();
    const alert = CusttomAlertController();
    const width = useScreenWidth();
    useEffect(() => {
        role.roleGetData(true, role.filter);
    }, []);
    return (
        <>
            <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການບົດບາດຜູ້ໃຊ້ງານ</Typography>


            <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: "15px" }}>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#f5f4f4',
                        borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                        borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
                    }}
                >
                    <Box>
                        <Header ctrl={role}
                            handleOpenDialog={() => role?.onHandleModal(RoleModalChildrenData.filter((e: RoleChildrenModel) => e.name.includes(RoleModalNames.CREATE))[0])}
                        />

                        <Divider sx={{ backgroundColor: '#D9D9D9' }} />

                        <Typography
                            fontSize={18}
                            sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
                        >
                            <AdminPanelSettingsOutlinedIcon />
                            <Typography marginLeft={"10px"}>
                                ຈັດການບົດບາດຜູ້ໃຊ້ງານ
                            </Typography>
                        </Typography>

                        <CustomRoleTable role={role} alert={alert} />
                    </Box>
                </Box>
            </Box>
            <RoleModalView ctrl={role} />
            <CustomAlertModal ctrl={alert} />
        </>
    )
}

export default RolePage;